import { render, staticRenderFns } from "./FolderSettingsDomain.vue?vue&type=template&id=1b19660b"
import script from "./FolderSettingsDomain.vue?vue&type=script&lang=js"
export * from "./FolderSettingsDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b19660b')) {
      api.createRecord('1b19660b', component.options)
    } else {
      api.reload('1b19660b', component.options)
    }
    module.hot.accept("./FolderSettingsDomain.vue?vue&type=template&id=1b19660b", function () {
      api.rerender('1b19660b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/folders/FolderSettingsDomain.vue"
export default component.exports